import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const getModulesByCreator = /* GraphQL */ `
  query GetModulesByCreator($creatorId: ID!) {
    getModulesByCreator(creatorId: $creatorId) {
      id
      name
      description
      recommendedPlayers
      minLevel
      maxLevel
      maxPartySize
      startingLevel
      difficulty
      estimatedPlayTime
      tags
      version
      status
      creatorId
      createdAt
      updatedAt
    }
  }
`;

const getModulesByStatus = /* GraphQL */ `
  query GetModulesByStatus($status: ModuleStatus!) {
    getModulesByStatus(status: $status) {
      id
      name
      description
      recommendedPlayers
      minLevel
      maxLevel
      maxPartySize
      startingLevel
      difficulty
      estimatedPlayTime
      tags
      version
      status
      creatorId
      createdAt
      updatedAt
    }
  }
`;

const createCustomGameModule = /* GraphQL */ `
  mutation CreateCustomGameModule($input: CreateGameModuleInput!) {
    createCustomGameModule(input: $input) {
      id
      name
      description
      scenes
      recommendedPlayers
      minLevel
      maxLevel
      maxPartySize
      startingLevel
      customSettings
      difficulty
      estimatedPlayTime
      tags
      version
      status
      creatorId
      createdAt
      updatedAt
    }
  }
`;

const updateCustomGameModule = /* GraphQL */ `
  mutation UpdateCustomGameModule($input: UpdateGameModuleInput!) {
    updateCustomGameModule(input: $input) {
      id
      name
      description
      scenes
      recommendedPlayers
      minLevel
      maxLevel
      maxPartySize
      startingLevel
      customSettings
      difficulty
      estimatedPlayTime
      tags
      version
      status
      creatorId
      createdAt
      updatedAt
    }
  }
`;

const deleteCustomGameModule = /* GraphQL */ `
  mutation DeleteCustomGameModule($input: DeleteGameModuleInput!) {
    deleteCustomGameModule(input: $input) {
      id
      name
      creatorId
      createdAt
      updatedAt
    }
  }
`;

export const fetchModulesByCreator = async (creatorId) => {
  try {
    const result = await client.graphql({
      query: getModulesByCreator,
      variables: { creatorId }
    });
    return result.data.getModulesByCreator;
  } catch (error) {
    console.error('Error fetching modules by creator:', error);
    throw error;
  }
};

export const fetchModulesByStatus = async (status) => {
  try {
    const result = await client.graphql({
      query: getModulesByStatus,
      variables: { status }
    });
    return result.data.getModulesByStatus;
  } catch (error) {
    console.error('Error fetching modules by status:', error);
    throw error;
  }
};

export const createGameModule = async (moduleData) => {
  try {
    const result = await client.graphql({
      query: createCustomGameModule,
      variables: { input: moduleData }
    });
    return result.data.createCustomGameModule;
  } catch (error) {
    console.error('Error creating game module:', error);
    throw error;
  }
};

export const updateGameModule = async (moduleData) => {
  try {
    const result = await client.graphql({
      query: updateCustomGameModule,
      variables: { input: moduleData }
    });
    return result.data.updateCustomGameModule;
  } catch (error) {
    console.error('Error updating game module:', error);
    throw error;
  }
};

export const deleteGameModule = async (moduleId) => {
  try {
    const result = await client.graphql({
      query: deleteCustomGameModule,
      variables: { input: { id: moduleId } }
    });
    return result.data.deleteCustomGameModule;
  } catch (error) {
    console.error('Error deleting game module:', error);
    throw error;
  }
};

const listGameModules = /* GraphQL */ `
  query ListGameModules(
    $filter: ModelGameModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGameModules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        recommendedPlayers
        minLevel
        maxLevel
        maxPartySize
        startingLevel
        difficulty
        estimatedPlayTime
        tags
        version
        status
        creatorId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Add this function to the existing functions in GameModuleAPI.js
export const fetchGameModules = async (filter, limit, nextToken) => {
  try {
    const result = await client.graphql({
      query: listGameModules,
      variables: { filter, limit, nextToken }
    });
    return result.data.listGameModules;
  } catch (error) {
    console.error('Error fetching game modules:', error);
    throw error;
  }
};